import React from 'react'
import { useParams } from 'react-router-dom'

import LanguageFilter from '../components/LanguageFilter'
import Mirador from '../components/Mirador'
import SideBarWrapper from '../components/SideBarWrapper'
import AnnotationsToggle from '../components/AnnotationsToggle'
import NoDeselectAnnotationsOverlay from '../components/NoDeselectAnnotationsOverlay'
import DeselectAnnotationButton from '../components/DeselectAnnotationButton'

interface IParams {
  manifestName: string
}

const Main: React.FC = () => {
  const { manifestName } = useParams<IParams>()
  return (
    <div className="App">
      <main className="App-main">
        <Mirador
          config={{
            id: 'mirador',
            manifest: manifestName,
          }}
          plugins={[
            SideBarWrapper,
            LanguageFilter,
            AnnotationsToggle,
            NoDeselectAnnotationsOverlay,
            DeselectAnnotationButton,
          ]}
        />
      </main>
    </div>
  )
}

export default Main
